import '@xyflow/react/dist/style.css';
import './style.css';
import useWorkflowStore from './store';
import {Resizable} from 're-resizable';
import {useState} from 'react';
export const Swimlanes = () => {
  const {setNodes, viewport, swimlanes, setSwimlanes} = useWorkflowStore();
  // Save swimlane positions and heights before resizing
  const [swimlaneResizing, setSwimlaneResizing] = useState<any>(undefined);
  return (
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
      {swimlanes.map((lane, index) => (
        <Resizable
          className="flex items-center justify-center"
          size={{width: '100%', height: lane.height * viewport.zoom}}
          enable={{top: false, right: false, bottom: true, left: false}}
          onResizeStart={() => {
            // save current position and height of swimlanes
            const sz = {};
            for (const l of swimlanes) {
              sz[l.id] = {y0: l.y, h0: l.height};
            }
            setSwimlaneResizing(sz);
            console.log('onResizeStart', sz);
          }}
          onResize={(e, direction, ref, d) => {
            if (!swimlaneResizing) return;
            console.log('onResize', e, direction, ref, d);
            const deltaH = d.height / viewport.zoom;
            setSwimlanes(lanes =>
              lanes.map(l => {
                if (l.id === lane.id) {
                  return {...l, height: swimlaneResizing[l.id].h0 + deltaH};
                } else if (l.y > lane.y) {
                  return {...l, y: swimlaneResizing[l.id].y0 + deltaH};
                }
                return l;
              }),
            );

            setNodes(nds =>
              nds.map(node => {
                const laneForNode = swimlanes.find(
                  l => node.position.y >= l.y && node.position.y < l.y + l.height,
                );
                if (laneForNode) {
                  const newLane = swimlanes.find(l => l.id === laneForNode.id);
                  if (newLane) {
                    return {
                      ...node,
                      position: {
                        ...node.position,
                        y: newLane.y + newLane.height / 2 - 25,
                      },
                    };
                  }
                }
                return node;
              }),
            );
          }}
          // onResizeStop={() => {
          //   // Take snapshot after resizing is complete
          //   takeSnapshot();
          // }}
          handleStyles={{
            bottom: {
              pointerEvents: 'auto',
            },
          }}
          key={lane.id}
          style={{
            pointerEvents: 'none',
            position: 'absolute',
            top: viewport.y + lane.y * viewport.zoom,
            left: 0,
            backgroundColor: 'transparent',
            borderTop: index == 0 ? `${4 * viewport.zoom}px dashed #ccc` : '',
            borderBottom: `${4 * viewport.zoom}px dashed #ccc`,
            // zIndex: 50,
          }}>
          <span
            style={{
              position: 'absolute',
              left: 10 * viewport.zoom,
              top: 10 * viewport.zoom,
              fontWeight: 'bold',
            }}>
            {lane.id}:{lane.label} ({lane.y}@{lane.height})
          </span>
        </Resizable>
      ))}
    </div>
  );
};
